var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#F8F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.5 17.5L14.5 29.5C14.5 31.7091 16.2909 33.5 18.5 33.5H24.5L32.5 25.5V17.5C32.5 15.2909 30.7091 13.5 28.5 13.5L18.5 13.5C16.2909 13.5 14.5 15.2909 14.5 17.5Z",
    fill: "#6B47F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 29.4999L24.5 33.4999L32.5 25.4999L28.5 25.4999C26.2909 25.4999 24.5 27.2908 24.5 29.4999Z",
    fill: "#6B47F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.25 21.6718C24.2967 21.6367 24.3414 21.5979 24.3839 21.5555L25.9697 19.9697C26.2626 19.6768 26.7374 19.6768 27.0303 19.9697C27.3232 20.2626 27.3232 20.7374 27.0303 21.0303L25.4445 22.6161C24.3706 23.6901 22.6294 23.6901 21.5555 22.6161L19.9697 21.0303C19.6768 20.7374 19.6768 20.2626 19.9697 19.9697C20.2626 19.6768 20.7374 19.6768 21.0303 19.9697L22.6161 21.5555C22.6586 21.5979 22.7033 21.6367 22.75 21.6718L22.75 17.5C22.75 17.0858 23.0858 16.75 23.5 16.75C23.9142 16.75 24.25 17.0858 24.25 17.5V21.6718Z",
    fill: "#6B47F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyDown);
export default __webpack_public_path__ + "static/media/PolicyDown.86511b1097d67bb4949914a9c871ff2a.svg";
export { ForwardRef as ReactComponent };